module.exports = __webpack_public_path__ + "img/cool.008b055.webp";